import React, { ReactElement, MouseEvent, useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'
import { useStateRef } from '../../../src/contracts/src/hooks'

export type VerticalMenuScrollProps = {
    settings: Array<Settings>
    indexActive: number
    toScrollId: string
}

type Settings = {
    title: string,
    id: string,
    show?: boolean
}

const OFFSET = 20

const VerticalMenuScroll = (props: VerticalMenuScrollProps): ReactElement => {
    const { toScrollId, settings, indexActive } = props
    const [active, setActive] = useState(indexActive || 0)

    useEffect(() => {

        const element = document.getElementById(toScrollId)

        if (element) {
            element.scroll({ top: 0 })
            element.addEventListener('scroll', handleScroll)

            return (): void => {
                element.removeEventListener('scroll', handleScroll)
            }
        }
    }, [toScrollId])

    const handleScroll = (e: any) => {

        const scrollElement = e.target;

        let index = 0;

        const maxScroll = scrollElement.scrollHeight - scrollElement.offsetHeight

        if (scrollElement.scrollTop >= maxScroll) {
            index = settings.length - 1;
        } else {
            for (let i = 0; i < settings.length; i++) {
                const element = document.getElementById(settings[i].id)

                if ((scrollElement.scrollTop + OFFSET) >= (element?.offsetTop || 0)) {
                    index = i
                } else {
                    break
                }
            }
        }

        setActive(index)
    }


    const onClickItem = (event: MouseEvent, index: number, id: string): void => {
        event.preventDefault()
        const scrollContainer = document.getElementById(toScrollId)
        //const offset = document.getElementById(settings[0].id)?.offsetTop || 0
        const selected = document.getElementById(id)


        if (selected) {
            scrollContainer?.scroll({
                top: (selected.offsetTop - OFFSET),
                behavior: 'smooth'
            })
        }
    }


    return (
        <Container {...props}>
            {settings?.map((setting: Settings, index: number) => {
                return (
                    <Content length={settings.length} active={active} index={index} key={index}>
                        <div
                            onClick={(event: MouseEvent): void => onClickItem(event, index, setting.id)}
                            className={'title'}
                        >
                            {setting.title}
                        </div>
                    </Content>
                )
            })}
        </Container>
    )
}
export default VerticalMenuScroll

const Container = styled.div`
    overflow: hidden;
    padding: 10px;
    width: 200px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
`

type ContentType = {
    active: number,
    index: number,
    length: number
}

// eslint-disable-next-line prettier/prettier
const Content =
    styled.div <ContentType>
        `
    display: flex;
    width: 100px;
    height: 40px;
    position: relative;
    align-items: flex-start;
    justify-content: flex-start;
    box-sizing: border-box;

    /* vertical line */
    &::after {
        content: '';
        width: 1px;
        height: 40px;
        margin-top: 5px;
        background-color: ${({ active, index }): string => (active === index ? '#37A3EF' : '#868695')};
        position: absolute;
        left: 1px;
    }

    /* dot */
    &::before {
        content: '';
        margin-top: 5px;
        width: ${({ active, index }): string => (active === index ? '7px' : '5px')};
        height: ${({ active, index }): string => (active === index ? '7px' : '5px')};
        border-radius: 50%;
        background-color: ${({ active, index }): string => (active === index ? '#37A3EF' : '#868695')};
        position: absolute;
        left: ${({ active, index }): string => (active === index ? '-2px' : '-1px')};
        z-index: 5;
    }
    &:nth-child(${({ length }): number => length}) {
        &::after {
            width: 0px;
            height: 0px;
        }
    }
    > .title {
        padding-left: 20px;
        width: 200px;
        line-height: 15px;
        color: ${({ active, index }): string => (active === index ? '#000000' : '#868695')};
        font-family: 'SourceSansPro-Bold', Arial, 'Helvetica Neue', Helvetica, sans-serif;
        font-style: normal;
        font-weight: ${({ active, index }): string => (active === index ? '600' : 'normal')};
        font-size: 11px;
        cursor: pointer;
    }
`
